import React from "react";
import { HiCheckBadge } from "react-icons/hi2";

const DevOps = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title">DevOps</h3>
            <div className="skills__box">
                <div className="skills__group">
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Docker</h3>
                            <span className="skills__level">Intermediário</span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Docker Compose</h3>
                            <span className="skills__level">Intermediário</span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Kubernetes</h3>
                            <span className="skills__level">Intermediário</span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Prometheus</h3>
                            <span className="skills__level">Básico</span>
                        </div>
                    </div>
                </div>
                <div className="skills__group">
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">TerraForm</h3>
                            <span className="skills__level">Intermediário</span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">AWS / Azure</h3>
                            <span className="skills__level">Intermediário</span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Docker Swarm</h3>
                            <span className="skills__level">Basico</span>
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Linux</h3>
                            <span className="skills__level">Intermediário</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DevOps;